export const authKeys = {
  all: ['auth'] as const,
  verify: (slug: string) => [...authKeys.all, 'verify', slug] as const,
  user: () => [...authKeys.all, 'user'] as const,
};
